module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_03_Beatpad.619c9206.png";